import { picoapp } from 'picoapp'

// Singleton picoapp instance. Exists as its own module so components that need
// to call app.mount() after DOM updates can import it without creating a cycle
// through pico-init.js (which imports those same components).
const app = picoapp({})
export default app
